// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function roles_from_string(role) {
  switch (role) {
    case "business_admin" :
        return /* BUSINESS_ADMIN */2;
    case "city_admin" :
        return /* CITY_ADMIN */1;
    case "user" :
        return /* USER */0;
    default:
      return ErrorUtils$Catalyst.raiseError("PricingCampaignRole.re", "Invalid role found", role);
  }
}

export {
  roles_from_string ,
  
}
/* No side effect */
